import React from "react";

interface Props {
  active: boolean;
}

const TreeViewElement: React.FC<Props> = ({ active, children }) => {
  return <ul className={`nested ${active ? "active" : ""}`}>{children}</ul>;
};

export default TreeViewElement;